import { useQuery } from 'react-query';

import { getCardUrgent as queryFn } from 'api/endPoints/getCardUrgent';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCardUrgent = (params: QueryParams) => {
    return useQuery<UrgentOptionsResponse[], QueryError, UrgentOptionsResponse[], [QueryKeys, unknown]>({
        queryKey: ['getCardUrgent', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
    });
};

export interface QueryParams {
    metaDataId?: IVersion['id'];
}

export interface UrgentOptionsResponse {
    id: number;
    label: string;
    name: string;
    numOfDays: number;
}
